<template>
    <BaseScaleSlider
        :options="options"
        :model-value="modelValue"
        :disabled="disabled"
        :label="label"
        :label-start="t('components.likertScale.disagree')"
        :label-end="t('components.likertScale.agree')"
        @update:model-value="(value) => emit('update:modelValue', value)"
        @confirm="(via) => emit('advance', via)" />
</template>

<script setup lang="ts">
/** The Perspective survey's seven point agreement scale, answering -3 (strongly disagree) to 3 (strongly agree). */
import BaseScaleSlider from "~vue/components/form/BaseScaleSlider.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { modelValue, disabled = false, label } = defineProps<{ modelValue?: number; disabled?: boolean; label?: string }>();

const emit = defineEmits<{
    "update:modelValue": [value: number];
    advance: [via: "pointer" | "keyboard"];
}>();

const { t } = useI18n();

const options = computed(() => [
    { value: -3, label: t("components.likertScale.stronglyDisagree") },
    { value: -2, label: t("components.likertScale.disagree") },
    { value: -1, label: t("components.likertScale.slightlyDisagree") },
    { value: 0, label: t("components.likertScale.neutral") },
    { value: 1, label: t("components.likertScale.slightlyAgree") },
    { value: 2, label: t("components.likertScale.agree") },
    { value: 3, label: t("components.likertScale.stronglyAgree") },
]);
</script>
